export default __webpack_public_path__ + "static/media/home.064bdc3f.svg";